import React, { useEffect, useState } from "react";
import DatePicker,  { registerLocale } from "react-datepicker";
import { Link, Redirect, useLocation } from "react-router-dom";

import de from 'date-fns/locale/de';
import en from 'date-fns/locale/en-GB';
import hr from 'date-fns/locale/hr';
import getMomentDateObj from "../../functions/getMomentDateObj";
import setMomentDateObjZero from "../../functions/setMomentDateObjZero";
import getOtherFilters from "../../functions/getOtherFilters";
import getTranslation from "../../functions/getTranslation";
import Translation from "../../General/Translation";

registerLocale('de', de)
registerLocale('en', en)
registerLocale('hr', hr)

function isInArray(array, value) {
    return !!array.find(item => {return item.getTime() == value.getTime()});
}

const DatepickerContainer = ({translation, otherFilters, movies, filterValuesStartDate = null, filterValuesEndDate = null}) => {
    let location = useLocation();
    const [startDate, setStartDate] = useState(filterValuesStartDate);
    const [endDate, setEndDate] = useState(filterValuesEndDate);
    const [redirectToPage, setRedirect] = useState(null);
    const dayFilterId = 'time'
    const dayFilterIdWithEqualSign = dayFilterId + '='
    const clickableDays = []
    
    useEffect(() => {
        if(filterValuesStartDate !== startDate) {
            const timestamp = setMomentDateObjZero(getMomentDateObj(startDate.getTime()))
            const otherSortValue = '?' + dayFilterIdWithEqualSign + 'start:' + timestamp
            const sortValue = getOtherFilters(otherFilters, otherSortValue)
            setRedirect(sortValue)
        }
    }, [startDate])

    useEffect(() => {
        if(filterValuesEndDate !== endDate) {
            const timestamp = setMomentDateObjZero(getMomentDateObj(endDate.getTime()))
            const otherSortValue = startDate ? '?' + dayFilterIdWithEqualSign + 'start:' + setMomentDateObjZero(getMomentDateObj(startDate.getTime())) +  '&' + dayFilterIdWithEqualSign + 'end:' + timestamp : '?' + dayFilterIdWithEqualSign + 'end:' + timestamp
            const sortValue = getOtherFilters(otherFilters, otherSortValue)
            setRedirect(sortValue)
        }
    }, [endDate])

    useEffect(() => {
        setStartDate(filterValuesStartDate)
        setEndDate(filterValuesEndDate)

    }, [filterValuesStartDate, filterValuesEndDate])

    if(movies) {
        _.keys(movies).map(moviePk => {
            const {performances} = movies[moviePk]

            performances.map(perf => {
                const {timeUtc} = perf
                const timestampOnZero = setMomentDateObjZero(getMomentDateObj(timeUtc))
                const date = new Date(timestampOnZero)
                const today = setMomentDateObjZero(getMomentDateObj(new Date().getTime()))

                if(!isInArray(clickableDays, date) && today <= timestampOnZero) {
                    clickableDays.push(date)
                }
            })
        })
    }
    
    const renderDayContents = (day, date) => {
        const timestamp = setMomentDateObjZero(getMomentDateObj(date.getTime()))
        const otherSortValue = '?' + dayFilterIdWithEqualSign + 'start:' + timestamp
        const sortValue = getOtherFilters(otherFilters, otherSortValue)
        return isInArray(clickableDays, date) ? <Link className={""} to={{search: sortValue}}>
            {date.getDate()}
        </Link> : <div className={"disabled"}>
            {date.getDate()}
        </div>
    };

    const renderDayContentsEnd = (day, date) => {
        const timestamp = setMomentDateObjZero(getMomentDateObj(date.getTime()))
        const otherSortValue = startDate ? '?' + dayFilterIdWithEqualSign + 'start:' + setMomentDateObjZero(getMomentDateObj(startDate.getTime())) +  '&' + dayFilterIdWithEqualSign + 'end:' + timestamp : '?' + dayFilterIdWithEqualSign + 'end:' + timestamp
        const sortValue = getOtherFilters(otherFilters, otherSortValue)
        return isInArray(clickableDays, date) ? <Link className={""} to={{search: sortValue}}>
            {date.getDate()}
        </Link> : <div className={"disabled"}>
            {date.getDate()}
        </div>
    };

    const otherSortValue = startDate ? '?' + dayFilterIdWithEqualSign + 'start:' + setMomentDateObjZero(getMomentDateObj(startDate.getTime())) : ''
    const sortValue = getOtherFilters(otherFilters, otherSortValue)
    return (
      <div className="datepicker-container">

        {redirectToPage && <Redirect
            to={{
                pathname: location.pathname,
                search: redirectToPage
            }}
        />}
        <div className="datepicker-label">
            <label><Translation id="startDate" trans={translation}>Statdatum</Translation>:</label>
            <div className="datepicker-flex">
                <DatePicker
                selected={startDate}
                dateFormat="dd.MM.yyyy"
                onChange={val => {
                    setStartDate(val)
                }}
                selectsStart
                locale={translation.currentLang}
                minDate={new Date()}
                includeDates={clickableDays}
                startDate={startDate}
                renderDayContents={renderDayContents}
                endDate={endDate}
                placeholderText={getTranslation('selectDate', translation)}
                wrapperClassName="text-light"
                />
                {startDate && <Link onClick={() => {
                    setStartDate(null)
                    setEndDate(null)
                }} className={"delete-button-wrapper"} to={{search:''}}>
                    <div className="delete-button"><span className="screen-reader-text">Delete</span></div>
                </Link>}
            </div>
        </div>
        <div className="datepicker-label">
            {startDate &&<label><Translation id="endDate" trans={translation}>Enddatum</Translation>:</label>}
            <div className="datepicker-flex">
                {startDate && <DatePicker
                selected={endDate}
                dateFormat="dd.MM.yyyy"
                onChange={val => setEndDate(val)}
                selectsEnd
                placeholderText={getTranslation('selectDate', translation)}
                locale={translation.currentLang}
                includeDates={clickableDays}
                startDate={startDate}
                endDate={endDate}
                renderDayContents={renderDayContentsEnd}
                wrapperClassName="text-light"
                minDate={startDate ? startDate : new Date()}
                />}
                {startDate && endDate && <Link onClick={() => {
                    setEndDate(null)
                }} className={"delete-button-wrapper"} to={{search: sortValue}}>
                    <div className="delete-button"><span className="screen-reader-text">Delete</span></div>
                </Link>}
            </div>
        </div>
      </div>
    )
}

export default DatepickerContainer